define('utils/bind-lifo-stack',['jquery'],
    function ($) {
        /**
         * Used to create stack of events that will be fired in LIFO order
         * It's written in order to use key "esc" in multiple opened ligtboxes that need to fired as LIFO
         */
        var BindLiloStack = (function () {
            function BindLiloStack () {
                this.stack = {};
                this.run();
            }

            BindLiloStack.prototype.pushEscapeCallback = function(callback) {
                this.stack.esc = this.stack.esc || [];
                this.stack.esc.push(callback);
            };

            BindLiloStack.prototype.getLastEscapeCallback = function(callback) {
                if (this.stack.esc && this.stack.esc.length) {
                    return this.stack.esc[this.stack.esc.length - 1];
                }

                return function() {};
            };

            BindLiloStack.prototype.popEscapeCallback = function() {
                if (this.stack.esc && this.stack.esc.length) {
                    this.stack.esc.pop(); 
                }
            };

            BindLiloStack.prototype.run = function() {
                var _this = this;

                $(document).on('keyup', function(e) {
                    if (e.keyCode == 27) {
                        _this.getLastEscapeCallback().call(this, e);
                        return;
                    }
                });
            };


            return BindLiloStack;
        })();

        return new BindLiloStack();
    }
);

